import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getColumns, stateColors, getColorState } from 'tasks/services/config/taskConfig';
import { getTaskDetail, getTasks, selectClient, selectDateFilter, setTaskSelected } from '../../actions';
import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, InputAdornment, TextField } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import SearchIcon from '@material-ui/icons/Search';
import BuildIcon from '@material-ui/icons/Build';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import ArchiveIcon from '@material-ui/icons/Archive';
import CancelIcon from '@material-ui/icons/Cancel';
import CloseIcon from '@material-ui/icons/Close';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import ReplayIcon from '@material-ui/icons/Replay';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CheckBudget from 'tasks/components/CheckBudget';
import CheckPaid from 'tasks/components/CheckPaid';
import SearchClient from 'tasks/components/SearchClient';
import TableTask from 'tasks/components/TableTask';
import TaskDetailsContainer from 'tasks/containers/TaskDetailsContainer';
import addTaskUseCase from 'tasks/services/addTaskUseCase';
import deleteTaskUseCase from 'tasks/services/deleteTaskUseCase';
import { printDocDevice } from 'tasks/services/printDocsUseCase';
import updateTaskUseCase from 'tasks/services/updateTaskUseCase';
import { getClients } from '../../clients/services/actions';
import { sendWhatsapp } from '../../common/services/util';
import showPDFSignUseCase from 'tasks/services/sign/showPDFSignUseCase';
import findClientByTask from 'tasks/services/sign/findClientByTask';
import { db } from 'common/config/Firebase';
import sendRecepcionByEmailUseCase from 'tasks/services/sendRecepcionByEmailUseCase';
import sendReparadoByEmailUseCase from 'tasks/services/sendReparadoByEmailUseCase';
import sendSinRepararByEmailUseCase from 'tasks/services/sendSinRepararByEmailUseCase';
import sendInformeEmailUseCase from 'tasks/services/sendInformeEmailUseCase';
import { getTasksData } from '../../common/store/reducers/tasks';
import addInvoiceFromTaskUseCase from 'tasks/services/addInvoiceFromTaskUseCase';
import { ArrowUpward, CheckBoxOutlineBlankOutlined, EuroSymbol } from '@material-ui/icons';
import paqueteEntregado from 'common/assets/paquete_entregado.png';
import Description from '@material-ui/icons/Description';
import updateColumnsOrderUseCase from 'common/services/updateColumnsOrderUseCase';
import findColumnsOrderUseCase from 'common/services/findColumnsOrderUseCase';
import SelectField from 'common/components/SelectField';
import SearcherPro from 'stock/components/SearcherPro';
import { filterTaskData } from 'tasks/services/filterTaskData';
import { getInvoices } from 'invoices/services/store/actions';
import addTicketFromTaskUseCase from 'tasks/services/addTicketFromTaskUseCase';
import { makeStatefulRowEffects } from 'common/services/makeStatefulRowEffects';
import IvaSwitch from 'invoices/components/IvaSwitch';
import { Typography } from '@material-ui/core';

class TaskListContainer extends Component {

    openBudgetReminder = () => {
        this.setState({ showBudgetReminder: true });
        setTimeout(() => this.setState({ showBudgetReminder: false }), 2000);
    }

    handleTaskAdd = newTask => {
        if (!newTask.budget || !newTask.unlockCode) {
            this.setState({
                openMissingFieldsDialog: true,
                pendingTask: newTask,
                pendingBudget: newTask.budget || '',
                pendingUnlockCode: newTask.unlockCode || '',
            });
            return Promise.reject('missing_fields');
        }
        return addTaskUseCase(newTask)
            .then(() => console.log("Se ha añadido la tarea"))
            .catch(error => console.log("Error con la tarea " + error))
    }

    handleConfirmPendingTask = () => {
        if (this.state.savingPendingTask) return;
        const { pendingTask, pendingBudget, pendingUnlockCode } = this.state;
        const taskToSave = { ...pendingTask, budget: pendingBudget, unlockCode: pendingUnlockCode };
        this.setState({ savingPendingTask: true });
        addTaskUseCase(taskToSave)
            .then(() => {
                console.log("Se ha añadido la tarea");
                this.setState({ openMissingFieldsDialog: false, pendingTask: null, pendingBudget: '', pendingUnlockCode: '', savingPendingTask: false });
                if (this.tableRef.current) {
                    this.tableRef.current.setState({ showAddRow: false });
                }
            })
            .catch(error => {
                console.log("Error con la tarea " + error);
                this.setState({ savingPendingTask: false });
            });
    }

    handleCreateRMA = (task) => {
        const sourceTask = task.data || task;
        this.setState({
            openReincidenciaDialog: true,
            reincidenciaTask: sourceTask,
            reincidenciaProblema: '',
        });
    }

    handleConfirmReincidencia = async () => {
        const { reincidenciaTask, reincidenciaProblema } = this.state;
        const rows = this.state.tasksSelected.length > 0
            ? this.state.tasksSelected
            : [reincidenciaTask];

        for (const row of rows) {
            const {
                id,
                reference,
                dateFinish,
                dateEntrySign,
                payed,
                budget,
                budgetAccept,
                dateAccepted,
                dateRepaired,
                ...rest
            } = row;

            const newTask = {
                ...rest,
                description: `🔄REINCIDENCIA - ${reincidenciaProblema.toUpperCase()}`,
                budget: null,
                budgetAccept: 0,
                dateAccepted: null,
                state: 0,        // En diagnóstico
                payed: 0,
                invoiced: 0,
                dateEntry: new Date().getTime(),
                dateFinish: null,
            };

            try {
                await addTaskUseCase(newTask);
            } catch (e) {
                console.error('Error creando reincidencia:', e);
            }
        }

        this.setState({ openReincidenciaDialog: false, reincidenciaTask: null, reincidenciaProblema: '', tasksSelected: [], selectAll: false });
    }

    handleTaskUpdate = (newTask, oldTask) => {
        const willShowBudgetReminder =
            (parseFloat(newTask.budget) || 0) > 0 &&
            (parseFloat(oldTask.budget) || 0) === 0 &&
            parseInt(newTask.state) === 0
        return updateTaskUseCase(newTask, oldTask).then(result => {
            if (willShowBudgetReminder) {
                this.openBudgetReminder();
            }
            return result
        })
    }

    handleTaskDelete = async (task) => {
        const tasks = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task]

        for (let i = 0; i < tasks.length; i++) {
            await deleteTaskUseCase(tasks[i])
        }

        this.setState({ ...this.state, tasksSelected: [] })
        return true
    }

    onSendWhatsApp = async (task, type) => {
        let message;

        if (type === 'reparado') {
            const device = (task.deviceName || '').toUpperCase();
            const ref = (task.reference || '').toUpperCase();
            const serial = (task.imei || '').toUpperCase();
            const clientRef = (task.refClient || '').toUpperCase();

            let intro = `El servicio técnico de IFENO le informa que su dispositivo *${device}*`;
            if (ref) intro += ` con *referencia IFENO ${ref}*`;
            if (serial) intro += `, *SERIAL/IMEI:* *${serial}*`;
            if (clientRef) intro += ` y *referencia cliente:* *${clientRef}*`;
            intro += ` está reparado y listo para su recogida.`;

            message = `${intro}\n\nPuede recogerlo en nuestra tienda durante nuestro horario comercial ( L-V de 10-14 y 16-20)`;
        } else if (type === 'sin_reparar') {
            const device = (task.deviceName || '').toUpperCase();
            const ref = (task.reference || '').toUpperCase();
            const serial = (task.imei || '').toUpperCase();
            const clientRef = (task.refClient || '').toUpperCase();

            let intro = `Le escribimos en referencia a su dispositivo *${device}*`;
            if (ref) intro += ` con *referencia IFENO ${ref}*`;
            if (serial) intro += `, *SERIAL/IMEI:* *${serial}*`;
            if (clientRef) intro += ` y *referencia cliente:* *${clientRef}*`;
            intro += ` que ha dejado en nuestro taller de reparación.`;

            message = `${intro}\n\nLamentablemente, después de realizar una exhaustiva evaluación y diagnóstico del dispositivo, nuestro equipo técnico ha llegado a la conclusión de que no es posible realizar la reparación necesaria.\n\nPor favor, tenga en cuenta que le devolveremos su dispositivo en las mismas condiciones en las que lo recibimos.\n\nSi tiene alguna pregunta o inquietud, estamos aquí para ayudarle en cualquier cosa que necesite.\n\nGracias por confiar en IFENO, esperamos poder ser de ayuda en el futuro.`;
        } else if (type === 'presupuesto') {
            const device = (task.deviceName || '').toUpperCase();
            const ref = (task.reference || '').toUpperCase();
            const serial = (task.imei || '').toUpperCase();
            const clientRef = (task.refClient || '').toUpperCase();
            const budget = task.budget || '';
            const description = (task.description || '[detallar intervención]').toUpperCase();
            const ivaText = task.iva !== false
                ? '(IVA y mano de obra incluidos)'
                : '(sin IVA, mano de obra incluida)';

            let intro = `El presupuesto de reparación de su dispositivo *${device}*`;
            if (ref) intro += ` con *referencia IFENO ${ref}*`;
            if (serial) intro += `, *SERIAL/IMEI:* *${serial}*`;
            if (clientRef) intro += ` y *referencia cliente:* *${clientRef}*`;
            intro += `, es de *${budget}€ ${ivaText}*.`;

            message = `${intro}\n\nEl trabajo a realizar es el siguiente:\n*${description}*\n\nPara proceder con la reparación, por favor confirme respondiendo "Acepto" a este mensaje.\n\nTodas las reparaciones cuentan con 3 meses de garantía, excepto en dispositivos que presenten daños por líquidos o hayan sido manipulados previamente.\n\nGracias por confiar en IFENO`;

            // Llamar antes de cualquier await para que Safari permita window.open
            sendWhatsapp(task, message);

            if (parseInt(task.state) !== 6) {
                await updateTaskUseCase({ ...task, state: 6, notifyPresupuesto: false }, task);
            } else {
                await updateTaskUseCase({ ...task, notifyPresupuesto: false }, task);
            }
            return;
        } else if (type === 'informe') {
            // Abrir ventana síncronamente antes de los await para que Safari lo permita
            const win = window.open('', '_blank');
            try {
                const clientData = await findClientByTask(task.dni);
                const detailSnap = await db.collection('tasksDetail').doc(task.id).get();
                const detailData = detailSnap.data() ? detailSnap.data() : { observations: [] };
                const url = await showPDFSignUseCase(task, clientData, detailData, 4, null);
                message = `Estimado cliente, le contactamos desde el Servicio Técnico de IFENO 🛠. A través del siguiente enlace podrá consultar el informe de su reparación: ${url}`;
                if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                    try { await navigator.clipboard.writeText(message); } catch (err) { console.error('Error al copiar al portapapeles', err); }
                }
                if (win) win.location.href = `https://api.whatsapp.com/send?phone=34${task.phone}&text=${encodeURIComponent(message)}`;
            } catch (err) {
                console.error('Error al generar informe para WhatsApp', err);
                if (win) win.close();
            }
            return;
        } else {
            message = `Estimado cliente, le contactamos desde el Servicio Técnico de IFENO 🛠`;
        }

        sendWhatsapp(task, message);

        if (type === 'reparado' && task.notifyReparado) {
            await updateTaskUseCase({ ...task, notifyReparado: false }, task);
        }
    }

    onSendEmail = async (task, type) => {
        this.setState({ sendingEmail: true, emailResult: null });
        try {
            if (type === 'recepcion') {
                await sendRecepcionByEmailUseCase(task);
            } else if (type === 'reparado') {
                await sendReparadoByEmailUseCase(task);
                if (task.notifyReparado) {
                    await updateTaskUseCase({ ...task, notifyReparado: false }, task);
                }
            } else if (type === 'sin_reparar') {
                await sendSinRepararByEmailUseCase(task);
            } else if (type === 'informe') {
                const detailSnap = await db.collection('tasksDetail').doc(task.id).get();
                const detailData = detailSnap.data() ? detailSnap.data() : { observations: [] };
                await sendInformeEmailUseCase({ data: task, detail: detailData });
                if (task.notifyPresupuesto) {
                    await updateTaskUseCase({ ...task, notifyPresupuesto: false }, task);
                }
            }
            this.setState({ sendingEmail: false, emailResult: { message: 'Correo enviado correctamente', success: true } });
        } catch (err) {
            const msg = (err.message === 'Este cliente no tiene email configurado' || err.message === 'Esta reparación no tiene cliente asignado')
                ? err.message
                : 'Error al enviar el correo';
            console.error('Error al enviar correo:', err);
            this.setState({ sendingEmail: false, emailResult: { message: msg, success: false } });
        }
    }

    handleChangePaid = (oldTask, flag) => {
        const newTask = { ...oldTask, payed: flag }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleChangeInvoiced = (oldTask, flag) => {
        const newTask = { ...oldTask, invoiced: flag }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleChangeCollected = (oldTask, flag) => {
        const newTask = { ...oldTask, collected: flag }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleChangeMaxImp = (oldTask, flag) => {
        const newTask = { ...oldTask, maxImportance: flag }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleChangeBudget = (oldTask, flag) => {
        const newTask = { ...oldTask, budgetAccept: flag }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleChangeTaskIva = (oldTask, newIva) => {
        const newTask = { ...oldTask, iva: newIva }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleChangeState = (oldTask, newState) => {
        const currentState = parseInt(oldTask.state);
        const nextState = parseInt(newState);

        // NOTA4: Cualquier estado → Reparando (5) sin presupuesto aceptado
        if (nextState === 5 && parseInt(oldTask.budgetAccept) !== 1) {
            this.setState({
                openDiagToRepairDialog: true,
                pendingStateTask: oldTask,
                diagToRepairImporte: oldTask.budget || '',
            });
            return;
        }

        // NOTA5: Cualquier estado → Pendiente confirmación cliente (6) sin presupuesto
        if (nextState === 6 && !(parseFloat(oldTask.budget) > 0)) {
            this.setState({
                openNoBudgetDialog: true,
                pendingStateTask: oldTask,
                noBudgetImporte: '',
            });
            return;
        }

        const newTask = { ...oldTask, state: newState }
        return updateTaskUseCase(newTask, oldTask)
    }

    handleConfirmDiagToRepair = () => {
        const { pendingStateTask, diagToRepairImporte } = this.state;
        const newTask = {
            ...pendingStateTask,
            state: 5,
            budgetAccept: 1,
            budget: diagToRepairImporte,
            dateAccepted: Date.now(),
        };
        updateTaskUseCase(newTask, pendingStateTask)
            .then(() => this.setState({
                openDiagToRepairDialog: false,
                pendingStateTask: null,
                diagToRepairImporte: '',
            }));
    }

    handleConfirmNoBudget = () => {
        const { pendingStateTask, noBudgetImporte } = this.state;
        const newTask = {
            ...pendingStateTask,
            state: 6,
            budget: noBudgetImporte,
        };
        updateTaskUseCase(newTask, pendingStateTask)
            .then(() => {
                this.setState({
                    openNoBudgetDialog: false,
                    pendingStateTask: null,
                    noBudgetImporte: '',
                });
                this.openBudgetReminder();
            });
    }

    async componentDidMount() {
        const { tasks, getTasks, clients, getClients, invoices, getInvoices } = this.props;

        this.setState({ ...this.state, loadingColumns: true })
        const orderColumns = await findColumnsOrderUseCase({ doc: 'task' })
        this.setState({ ...this.state, orderColumns })

        const checkedPaid = (props) => {
            return (
                <CheckPaid
                    props={props}
                    field="payed"
                    handleChangePaid={this.handleChangePaid}
                    icon={<CheckBoxOutlineBlankOutlined />}
                    checkedIcon={<EuroSymbol />}
                />
            )
        }

        const checkedInvoiced = (props) => {
            return (
                <CheckPaid
                props={props}
                field="invoiced"
                handleChangePaid={this.handleChangeInvoiced}
                icon={<CheckBoxOutlineBlankOutlined />}
                checkedIcon={<Description />}
                />
            )
        }

        const checkedCollected = (props) => {
            return (
                <CheckPaid
                    props={props}
                    field="collected"
                    handleChangePaid={this.handleChangeCollected}
                    icon={<CheckBoxOutlineBlankOutlined />}
                    checkedIcon={<img src={paqueteEntregado} alt="Recogido" style={{ width: 20, height: 20, filter: 'brightness(0) saturate(100%) invert(29%) sepia(96%) saturate(617%) hue-rotate(181deg) brightness(97%) contrast(95%)' }} />}
                />
            )
        }

        const checkedMaxImp = (props, maxImportance) => {
            return (
                <CheckPaid
                    props={props}
                    field="maxImportance"
                    maxImportance={maxImportance}
                    handleChangePaid={this.handleChangeMaxImp}
                    checkedIcon={<ArrowUpward />}
                />
            )
        }

        const checkedBudget = (props, maxImportance, isPayed) => {
            return (
                <CheckBudget props={props} maxImportance={maxImportance} handleChangeBudget={this.handleChangeBudget} isPayed={isPayed} />
            )
        }

        const checkedTaskIva = (props) => {
            if (!props) return null
            const client = this.props.clients[props.dni]
            const ivaValue = props.iva !== undefined ? props.iva !== false : true
            return (
                <IvaSwitch
                    checked={ivaValue}
                    onChange={() => this.handleChangeTaskIva(props, !ivaValue)}
                />
            )
        }

        const checkedSelected = (props) => {
            if (!props) {
                return
            }

            return (
                <CheckPaid props={props}
                    field="selected"
                    handleChangePaid={this.handleCheckedSelected}
                    deselect={!this.state.tasksSelected.length}
                    select={this.state.tasksSelected.some(task => task.reference === props.reference)}
                />
            )
        }

        const searchClient = props => {
            return (
                <SearchClient props={props} handleTab={() => {
                    const input = document.querySelector("input[placeholder='Cliente']")
                    input.focus()
                }} handleSelect={() => {
                    const input = document.querySelector("input[placeholder='Dispositivo']")
                    input.focus()
                }} />
            )
        }

        const reference = props => {
            if (!props) {
                return
            }

            const isSelected = this.state.tasksSelected.some(
                t => t.reference === props.reference
            );

            const inTaller = parseInt(props.state) === 2 && !props.collected;

            return (
                <Button
                    variant="outlined"
                    style={{
                        width: '100%',
                        color: isSelected ? '#ff0202ff' : 'black',
                        backgroundColor: isSelected ? '#FDE0EA' : 'transparent',
                        fontWeight: 'bold',
                        border: isSelected ? '2px solid #000000ff' : '2px solid black',
                        borderRadius: '6px'
                    }}
                    onClick={() => this.handleOpenDialog(props)}
                    >
                    {props.observations && (
                        <WarningIcon
                        style={{
                            color: isSelected ? 'white' : 'yellow',
                            position: 'absolute',
                            fontSize: '15px',
                            left: '5px'
                        }}
                        />
                    )} {props.reference}
                    {inTaller && (
                        <div style={{ position: 'absolute', right: '5px', width: 16, height: 16, display: 'inline-flex' }}>
                            <img src={paqueteEntregado} alt="Sin recoger" style={{ width: 16, height: 16 }} />
                            <div style={{ position: 'absolute', inset: 0 }}>
                                <div style={{
                                    position: 'absolute', inset: 0,
                                    background: 'linear-gradient(to top right, transparent calc(50% - 0.6px), red calc(50% - 0.6px), red calc(50% + 0.6px), transparent calc(50% + 0.6px))'
                                }} />
                                <div style={{
                                    position: 'absolute', inset: 0,
                                    background: 'linear-gradient(to bottom right, transparent calc(50% - 0.6px), red calc(50% - 0.6px), red calc(50% + 0.6px), transparent calc(50% + 0.6px))'
                                }} />
                            </div>
                        </div>
                    )}
                </Button>
            )
        }

        const stateIcons = {
            0: SearchIcon,
            1: FlightTakeoffIcon,
            2: CheckCircleIcon,
            3: ArchiveIcon,
            4: CancelIcon,
            5: BuildIcon,
            6: HourglassEmptyIcon,
            7: LocalShippingIcon,
        };

        const selectState = ({ rowData, states, value }) => {
            const badgeMap = {};
            if (rowData.notifyReparado && parseInt(rowData.state) === 2) badgeMap[2] = <NotificationsIcon style={{ fontSize: 13, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} />;
            if (rowData.notifyPresupuesto && parseInt(rowData.state) === 6) badgeMap[6] = <NotificationsIcon style={{ fontSize: 13, color: '#FFC107', filter: 'drop-shadow(0 0 1.5px rgba(0,0,0,0.7))' }} />;
            return (
                <SelectField
                    mapData={states}
                    value={value}
                    iconMap={stateIcons}
                    colorMap={stateColors}
                    badgeMap={badgeMap}
                    handleChangeValue={value => this.handleChangeState(rowData, value)}
                />
            )
        }

        const checkAll = () => {
            return (
                <Checkbox checked={this.state.selectAll} onChange={e => this.handleSelectAll(e.target.checked)} />
            )
        }

        this.columns = getColumns(checkedPaid, checkedInvoiced, checkedBudget, searchClient, reference, checkedMaxImp, checkedSelected, selectState, this.state.orderColumns, checkAll, checkedCollected, checkedTaskIva)

        this.setState({ ...this.state, loadingColumns: false })

        if (tasks.length === 0) {
            getTasks();
        }

        if (clients.length === 0) {
            getClients()
        }

        if (invoices.length === 0) {
            getInvoices()
        }
    }

    handleOpenDialog = task => {
        this.props.setTaskSelected({ taskSelected: task });
        this.props.getTaskDetail({ id: task.id });
        this.setState({ open: true });
    }

    handleSignTaskPriority = async (oldTask) => {
        const newTask = { ...oldTask, dateEntrySign: new Date().getTime() }
        await updateTaskUseCase(newTask, oldTask)
        alert("Tarea enviada a firmar")
    }

    handleCheckedSelected = (task, flag) => {
        if (flag) {
            this.setState({ ...this.state, tasksSelected: [...this.state.tasksSelected, task] })
            this.props.tasks[task.id].selected = true
            return
        }

        const tasksSelected = this.state.tasksSelected.filter(taskSelect => taskSelect.reference !== task.reference)
        this.setState({ ...this.state, tasksSelected })
    }

    handlePrintDocDevice = task => {
        const dataList = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task]
        printDocDevice({ dataList })
        this.setState({ ...this.state, tasksSelected: [], selectAll: false })
    }

    handleAddInvoice = task => {
        this.setState({
            ...this.state,
            openDialogTask: true,
            taskToAdd: {
                ...task,
                data: {
                    ...task.data,
                    paymentMode: Number(task?.data?.paymentMode ?? 1), // 1 = Tarjeta
                },
            },
        })
    }

    handleAddTicket = task => {
        const dataList = this.state.tasksSelected.length > 0 ? this.state.tasksSelected : [task.data]
        addTicketFromTaskUseCase(dataList)
    }

    handleAddInvoiceFunc = (task, isProfoma) => {
        const hasSelection = this.state.tasksSelected.length > 0;

        const dataList = hasSelection
            ? this.state.tasksSelected.map(t => ({
                ...t,
                paymentMode: Number(t?.paymentMode ?? 1),
            }))
            : [
                {
                    ...task.data,
                    paymentMode: Number(task?.data?.paymentMode ?? 1),
                },
            ];

        addInvoiceFromTaskUseCase(dataList, isProfoma)
        this.setState({ ...this.state, tasksSelected: [], taskToAdd: {}, selectAll: false })
    }

    handleColumnDrag = async (cols) => {
        const arr = document.getElementsByClassName("MuiInputBase-input")
        Array.from(arr).forEach(el => {
            el.blur()
        })
        await updateColumnsOrderUseCase({ columns: cols, doc: 'task' })
    }

    handleSelectAll = flag => {
        if (flag) {
            const tasksSelected = this.tableRef.current.dataManager.searchedData
            this.setState({ ...this.state, tasksSelected, selectAll: flag })
            return
        }

        this.setState({ ...this.state, tasksSelected: [], selectAll: flag })
    }

    handleSearchText = text => {
        const searchData = { text }
        this.setState({ ...this.state, searchData })
    }

    getTaskDataFilter = tasks => {
        const order = task => {
            if (task.maxImportance === 1)
                return task.dateEntry + Date.now() + Date.now()

            return task.dateEntry
        }

        const taskData = getTasksData(tasks)
            .map(task => {
                const client = this.props.clients[task.dni] || { numberTasks: 0 }
                return { ...task, numberTasks: client.numberTasks || 0, dateEntryOrder: order(task) }
            })

        return filterTaskData(taskData, this.state.searchData.text)
    }

    constructor(props) {
        super(props);
        this.tableRef = React.createRef()
        this.state = {
            open: false,
            saving: false,
            sendingEmail: false,
            emailResult: null,   // { message, success }
            openMissingFieldsDialog: false,
            pendingTask: null,
            pendingBudget: '',
            pendingUnlockCode: '',
            savingPendingTask: false,

            // NOTA4: diálogo En diagnóstico → Reparando sin presupuesto aceptado
            openDiagToRepairDialog: false,
            pendingStateTask: null,
            diagToRepairImporte: '',

            // NOTA5: diálogo → Pendiente confirmación cliente sin presupuesto
            openNoBudgetDialog: false,
            noBudgetImporte: '',
            showBudgetReminder: false,

            // Crear reincidencia
            openReincidenciaDialog: false,
            reincidenciaTask: null,
            reincidenciaProblema: '',

            tasksSelected: [],
            taskData: [],
            loadingColumns: false,
            orderColumns: {},
            openDialogTask: false,
            taskToAdd: {},
            selectAll: false,
            searchData: {
                text: ""
            }
        };
    }

    render() {
        const { tasks, loading } = this.props;
        const { open, tasksSelected } = this.state;

        const isMobile = window.matchMedia('(max-width:600px)').matches;

        const baseRowStyle = makeStatefulRowEffects({
            baseStyle: (row) => ({ backgroundColor: getColorState(row) }),
            isSelected: (row) => this.state.tasksSelected.some(t => t.reference === row.reference),
            selectedOutline: '3.5px solid #000100ff',
            hoverOpacity: 0.7,
            selectedHoverOpacity: 0.5
        });


        const getRowStyle = (rowData, index) => {
           return baseRowStyle(rowData, index);
        };

        const handleCloseDialog = () => this.setState({ open: false });


        const handleOrder = () => {

        }

        let comSelect;

        if (tasksSelected.length > 0 && tasksSelected.length < 10) {
            comSelect =
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS:</span> {this.state.tasksSelected.map(task => task.reference).join(', ')}</span>
                </div>
        } else if (tasksSelected.length >= 10) {
            comSelect =
                <div style={{ display: 'flex', height: '40px', alignItems: 'center', backgroundColor: 'rgb(253, 224, 234)', color: 'red', paddingLeft: '10px', fontSize: '1.2rem', borderTopRightRadius: '4px', borderTopLeftRadius: '4px' }}>
                    <span><span style={{ fontWeight: 'bold' }}>TAREAS SELECCIONADAS:</span> {this.state.tasksSelected.length}</span>
                </div>
        }

        const { text: textSearch } = this.state.searchData

        return (
            <div style={{ padding: '20px 20px 20px 20px' }}>
                {this.state.sendingEmail && (
                    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: '#fff' }} size={60} />
                    </div>
                )}             
                {!this.state.loadingColumns && <SearcherPro
                    textSearch={textSearch}
                    handleChangeTextSearch={this.handleSearchText}
                />}
                {comSelect}
                {!this.state.loadingColumns && <TableTask
                    ref={this.tableRef}
                    data={this.getTaskDataFilter(tasks)}
                    dateFilter={this.props.dateFilter}
                    columns={this.columns}
                    loading={loading}
                    onTaskAdd={this.handleTaskAdd}
                    onTaskUpdate={this.handleTaskUpdate}
                    onTaskDelete={this.handleTaskDelete}
                    onRowClick={this.handlePrintDocDevice}
                    onSendWhatsApp={this.onSendWhatsApp}
                    onSendEmail={this.onSendEmail}
                    onCreateInvoice={this.handleAddInvoice}
                    onCreateTicket={this.handleAddTicket}
                    onCreateRMA={this.handleCreateRMA}
                    onDateFilterChange={dateFilter => {
                        this.props.selectDateFilter({ dateFilter })
                        this.props.getTasks()
                    }}
                    onOrderChange={handleOrder}
                    onSignTaskPriority={this.handleSignTaskPriority}
                    onColumnDrag={this.handleColumnDrag}
                    tableRefProp={this.tableRef}
                    selectAll={this.state.selectAll}
                    onSelectAll={this.handleSelectAll}
                    getRowStyle={getRowStyle}
                >
                </TableTask>}
                <TaskDetailsContainer
                    open={open}
                    handleClose={handleCloseDialog}>
                </TaskDetailsContainer>
                <Dialog open={this.state.openDialogTask}>
                    <DialogTitle>Crear factura</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Quieres crear una proforma o factura?
                        </DialogContentText>
                        <DialogActions>
                            <Button onClick={() => this.setState({ ...this.state, openDialogTask: false })}>
                                Cancelar
                            </Button>
                            <Button onClick={() => this.handleAddInvoiceFunc(this.state.taskToAdd, true)}>
                                Crear proforma
                            </Button>
                            <Button onClick={() => this.handleAddInvoiceFunc(this.state.taskToAdd)}>
                                Crear factura
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.openMissingFieldsDialog}
                    maxWidth="xs"
                    fullWidth
                    onClose={() => this.setState({ openMissingFieldsDialog: false })}
                    onKeyDown={e => {
                        if (e.key === 'Enter' && !this.state.savingPendingTask) this.handleConfirmPendingTask();
                        if (e.key === 'Escape') this.setState({ openMissingFieldsDialog: false });
                    }}
                >
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24, position: 'relative' }}>
                        <IconButton size="small" onClick={() => this.setState({ openMissingFieldsDialog: false })} style={{ position: 'absolute', top: 8, right: 8 }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        <WarningIcon style={{ color: '#f59e0b', fontSize: 32 }} />
                        <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>Campos sin rellenar</span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText style={{ color: '#333', marginBottom: 8, textAlign: 'center' }}>
                            No has rellenado todos los campos. Puedes completarlos ahora o dejarlos vacíos.
                        </DialogContentText>
                        {!this.state.pendingTask?.budget &&
                            <TextField
                                label="Presupuesto"
                                type="number"
                                fullWidth
                                margin="dense"
                                value={this.state.pendingBudget}
                                onChange={e => this.setState({ pendingBudget: e.target.value })}
                            />
                        }
                        {!this.state.pendingTask?.unlockCode &&
                            <TextField
                                label="Desbloqueo"
                                fullWidth
                                margin="dense"
                                value={this.state.pendingUnlockCode}
                                onChange={e => this.setState({ pendingUnlockCode: e.target.value })}
                            />
                        }
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                        <Button color="primary" variant="contained" disableElevation onClick={this.handleConfirmPendingTask} disabled={this.state.savingPendingTask}>
                            {this.state.savingPendingTask ? 'Guardando...' : 'Guardar tarea'}
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* Diálogo Crear reincidencia */}
                <Dialog
                    open={this.state.openReincidenciaDialog}
                    maxWidth="xs"
                    fullWidth
                    onClose={() => this.setState({ openReincidenciaDialog: false, reincidenciaTask: null, reincidenciaProblema: '' })}
                    onKeyDown={e => {
                        if (e.key === 'Escape') this.setState({ openReincidenciaDialog: false, reincidenciaTask: null, reincidenciaProblema: '' });
                        if (e.key === 'Enter' && this.state.reincidenciaProblema.trim()) this.handleConfirmReincidencia();
                    }}
                >
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24, position: 'relative' }}>
                        <IconButton size="small" onClick={() => this.setState({ openReincidenciaDialog: false, reincidenciaTask: null, reincidenciaProblema: '' })} style={{ position: 'absolute', top: 8, right: 8 }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        <ReplayIcon style={{ fontSize: 32, color: '#555' }} />
                        <span style={{ fontSize: '1.1rem', fontWeight: 600, textAlign: 'center' }}>
                            Crear reincidencia
                        </span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText style={{ color: '#333', marginBottom: 8, textAlign: 'center' }}>
                            Describe el problema actual del dispositivo
                        </DialogContentText>
                        <TextField
                            label="Problema actual"
                            fullWidth
                            margin="dense"
                            value={this.state.reincidenciaProblema}
                            onChange={e => this.setState({ reincidenciaProblema: e.target.value })}
                            placeholder="Ej: VUELVE A FALLAR CARGA"
                            autoFocus
                        />
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'space-between', padding: '12px 16px' }}>
                        <Button
                            startIcon={<CancelIcon />}
                            onClick={() => this.setState({ openReincidenciaDialog: false, reincidenciaTask: null, reincidenciaProblema: '' })}
                        >
                            Cancelar
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disableElevation
                            startIcon={<CheckCircleIcon />}
                            disabled={!this.state.reincidenciaProblema.trim()}
                            onClick={this.handleConfirmReincidencia}
                        >
                            Crear reincidencia
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* NOTA4: En diagnóstico → Reparando sin presupuesto aceptado */}
                <Dialog
                    open={this.state.openDiagToRepairDialog}
                    maxWidth="xs"
                    fullWidth
                    onClose={() => this.setState({ openDiagToRepairDialog: false, pendingStateTask: null, diagToRepairImporte: '' })}
                    onKeyDown={e => {
                        if (e.key === 'Escape') this.setState({ openDiagToRepairDialog: false, pendingStateTask: null, diagToRepairImporte: '' });
                        if (e.key === 'Enter' && this.state.diagToRepairImporte) this.handleConfirmDiagToRepair();
                    }}
                >
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24, position: 'relative' }}>
                        <IconButton size="small" onClick={() => this.setState({ openDiagToRepairDialog: false, pendingStateTask: null, diagToRepairImporte: '' })} style={{ position: 'absolute', top: 8, right: 8 }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        <WarningIcon style={{ color: '#f59e0b', fontSize: 32 }} />
                        <span style={{ fontSize: '1rem', fontWeight: 600, textAlign: 'center' }}>
                            Este presupuesto no está aceptado. Debes confirmar el importe con el cliente antes de iniciar la reparación.
                        </span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <TextField
                            label="Importe"
                            type="number"
                            fullWidth
                            margin="dense"
                            value={this.state.diagToRepairImporte}
                            onChange={e => this.setState({ diagToRepairImporte: e.target.value })}
                            autoFocus
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EuroSymbol style={{ fontSize: 16 }} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'space-between', padding: '12px 16px' }}>
                        <Button
                            startIcon={<CancelIcon />}
                            onClick={() => this.setState({ openDiagToRepairDialog: false, pendingStateTask: null, diagToRepairImporte: '' })}
                        >
                            Cancelar
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disableElevation
                            startIcon={<CheckCircleIcon />}
                            disabled={!this.state.diagToRepairImporte}
                            onClick={this.handleConfirmDiagToRepair}
                        >
                            Confirmar y aceptar presupuesto
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* NOTA5: → Pendiente confirmación cliente sin presupuesto */}
                <Dialog
                    open={this.state.openNoBudgetDialog}
                    maxWidth="xs"
                    fullWidth
                    onClose={() => this.setState({ openNoBudgetDialog: false, pendingStateTask: null, noBudgetImporte: '' })}
                    onKeyDown={e => {
                        if (e.key === 'Escape') this.setState({ openNoBudgetDialog: false, pendingStateTask: null, noBudgetImporte: '' });
                        if (e.key === 'Enter' && this.state.noBudgetImporte) this.handleConfirmNoBudget();
                    }}
                >
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24, position: 'relative' }}>
                        <IconButton size="small" onClick={() => this.setState({ openNoBudgetDialog: false, pendingStateTask: null, noBudgetImporte: '' })} style={{ position: 'absolute', top: 8, right: 8 }}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                        <WarningIcon style={{ color: '#f59e0b', fontSize: 32 }} />
                        <span style={{ fontSize: '1rem', fontWeight: 600, textAlign: 'center' }}>
                            Esta reparación no tiene presupuesto. Introduce el precio antes de enviarle el presupuesto al cliente.
                        </span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <TextField
                            label="Importe"
                            type="number"
                            fullWidth
                            margin="dense"
                            value={this.state.noBudgetImporte}
                            onChange={e => this.setState({ noBudgetImporte: e.target.value })}
                            autoFocus
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EuroSymbol style={{ fontSize: 16 }} />
                                    </InputAdornment>
                                )
                            }}
                        />
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'space-between', padding: '12px 16px' }}>
                        <Button
                            startIcon={<CancelIcon />}
                            onClick={() => this.setState({ openNoBudgetDialog: false, pendingStateTask: null, noBudgetImporte: '' })}
                        >
                            Cancelar
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disableElevation
                            startIcon={<CheckCircleIcon />}
                            disabled={!this.state.noBudgetImporte}
                            onClick={this.handleConfirmNoBudget}
                        >
                            Confirmar precio
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Modal recordatorio tras confirmar presupuesto sin precio previo */}
                <Dialog open={this.state.showBudgetReminder} maxWidth="xs" fullWidth onClose={() => this.setState({ showBudgetReminder: false })}>
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24 }}>
                        <NotificationsIcon style={{ color: '#f59e0b', fontSize: 32 }} />
                        <span style={{ fontSize: '1rem', fontWeight: 600, textAlign: 'center' }}>
                            No olvides enviarle el presupuesto al cliente
                        </span>
                    </DialogTitle>
                    <DialogActions style={{ justifyContent: 'center', padding: '12px 16px' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            disableElevation
                            startIcon={<CheckCircleIcon />}
                            onClick={() => this.setState({ showBudgetReminder: false })}
                        >
                            Entendido
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={Boolean(this.state.emailResult)} onClose={() => this.setState({ emailResult: null })} maxWidth="xs" fullWidth>
                    <DialogTitle disableTypography style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, paddingBottom: 8, paddingTop: 24 }}>
                        {this.state.emailResult?.success
                            ? <CheckCircleIcon style={{ color: '#43a047', fontSize: 32 }} />
                            : <ErrorIcon style={{ color: '#e53935', fontSize: 32 }} />
                        }
                        <span style={{ fontSize: '1.1rem', fontWeight: 600 }}>
                            {this.state.emailResult?.success ? 'Correo enviado' : 'Error'}
                        </span>
                    </DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText style={{ color: '#333', marginBottom: 0, textAlign: 'center' }}>
                            {this.state.emailResult?.message}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                        <Button onClick={() => this.setState({ emailResult: null })} color="primary" variant="contained" disableElevation>
                            Aceptar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

TaskListContainer.propTypes = {

};

const mapDispatchToProps = dispatch => ({
    getTasks: payload => dispatch(getTasks(payload)),
    setTaskSelected: payload => dispatch(setTaskSelected(payload)),
    getTaskDetail: payload => dispatch(getTaskDetail(payload)),
    getClients: payload => dispatch(getClients(payload)),
    selectClient: payload => dispatch(selectClient(payload)),
    selectDateFilter: payload => dispatch(selectDateFilter(payload)),
    getInvoices: payload => dispatch(getInvoices(payload))
});

const mapStateToProps = state => ({
    tasks: state.tasks.data,
    invoices: state.invoices.data,
    loading: state.tasks.loading,
    clients: state.clients.data,
    dateFilter: state.tasks.dateFilter
});

export default connect(mapStateToProps, mapDispatchToProps)(TaskListContainer);